import { motion, useReducedMotion } from 'framer-motion'
import type { ReactNode } from 'react'

interface RevealProps {
  children: ReactNode
  className?: string
  /** Seconds to delay the entrance (used for simple stagger). */
  delay?: number
  /** Distance in px the element rises from. */
  y?: number
  /** Optional id passed through to the wrapper (for anchor targets). */
  id?: string
}

/**
 * Scroll-reveal wrapper. Fades + rises content into view once.
 * Collapses to a static render under prefers-reduced-motion.
 */
export function Reveal({ children, className, delay = 0, y = 24, id }: RevealProps) {
  const reduce = useReducedMotion()

  return (
    <motion.div
      id={id}
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  )
}
